import { HealthNavigator, HealthNavigatorResponse, NAVIGATOR_STATUS } from '@abiglobalhealth/go-types'
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from 'react'

import { getInitialNavigatorMessage } from '@/utils/navigator'

export interface NavigatorContextProps {
  onGoingConversation: boolean
  setOnGoingConversation: Dispatch<SetStateAction<boolean>>
  navigator: HealthNavigatorResponse
  setNavigator: Dispatch<SetStateAction<HealthNavigatorResponse>>
  messages: HealthNavigator['messages']
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
  pendingMessage: string | null
  setPendingMessage: Dispatch<SetStateAction<string | null>>
}

export const NavigatorContext = createContext({} as NavigatorContextProps)

export const NavigatorProvider = ({ children }: PropsWithChildren) => {
  const [onGoingConversation, setOnGoingConversation] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [pendingMessage, setPendingMessage] = useState<string | null>(null)
  const [navigator, setNavigator] = useState<NavigatorContextProps['navigator']>({
    healthNavigator: {
      messages: []
    },
    navigatorName: '',
    partnerName: '',
    isFirstTime: false,
    isServiceSelected: false,
    status: NAVIGATOR_STATUS.RESOLVED
  })

  const value = {
    onGoingConversation,
    setOnGoingConversation,
    messages: [getInitialNavigatorMessage(navigator), ...navigator.healthNavigator.messages],
    navigator,
    setNavigator,
    loading: loading || navigator.status === NAVIGATOR_STATUS.PENDING,
    setLoading,
    pendingMessage,
    setPendingMessage
  }

  return <NavigatorContext.Provider value={value}>{children}</NavigatorContext.Provider>
}
